import { Button, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { useCreateAssessment } from './hooks';
import { ArrowDropDown } from '@mui/icons-material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { theme } from '@store';

interface ICreateAssessmentProps {
  patient_id: string;
  disabled: boolean;
  setItemEditId: (id: string) => void;
}

export const CreateAssessment = ({
  patient_id,
  disabled,
  setItemEditId,
}: ICreateAssessmentProps) => {
  const {
    handleClick,
    handleClose,
    anchorEl,
    open,
    assessmentTypeOptions,
    handleCreate,
    isLoading,
    handleGenerateLink,
  } = useCreateAssessment(patient_id, setItemEditId);

  return (
    <>
      <Button
        endIcon={<ArrowDropDown />}
        sx={{
          fontWeight: 'regular',
          fontSize: '1rem',
          bordercolor: 'primary.main',
          height: 'fit-content',
        }}
        variant='outlined'
        onClick={handleClick}
        disabled={isLoading || disabled}
      >
        ADD
      </Button>
      <Menu
        id='add-option-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        {assessmentTypeOptions.map(item => (
          <MenuItem
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              gap: '1rem',
            }}
            onClick={() => handleCreate(item.value)}
            key={item.value}
            disabled={isLoading}
          >
            {item.label}
            {item.can_link_be_generated && (
              <Tooltip title={'Copy link to assessment'}>
                <IconButton
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    mr: '0.5rem',
                    borderRadius: '8px',
                    position: 'relative',
                    p: '6px',
                  }}
                  onClick={e => handleGenerateLink(e, item.value)}
                >
                  <ContentCopyIcon
                    sx={{
                      color: theme.palette.semiBlack.main,
                      fontSize: `24px`,
                    }}
                  />
                </IconButton>
              </Tooltip>
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
